/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { NavHOC } from "./nav_hoc";
import { Footer } from "Views/presentational/footer";
import { HTML_ENTITIES } from "Lib/ts/html_entities";
import { DESIGN_TOKEN } from "Config/design_token";

type BaseLayoutProps = React.PropsWithChildren<{}>;

function baseLayout(props: BaseLayoutProps): JSX.Element {
  const { children } = props;

  const [navExpanded, setNavExpanded] = React.useState(false);

  return (
    <React.Fragment>
      <div
        css={css`
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          width: auto;
          max-width: 1440px;
          height: auto;
          margin: 0rem auto;
          background-color: ${DESIGN_TOKEN.colors.swatch_3};
          box-shadow: 0rem 0rem 1rem rgba(0, 0, 0, 0.2);
        `}
      >
        <NavHOC onExpand={expand => setNavExpanded(expand)} />
        <div
          css={css`
            display: flex;
            flex-grow: 1;
            flex-direction: column;
            width: 100%;
            height: auto;
            ${navExpanded &&
              `
                position: fixed;
                max-height: 100vh;
                overflow: hidden;
              `}
          `}
        >
          {children}
        </div>
      </div>
      <Footer>
        <div
          css={css`
            font-family: ${DESIGN_TOKEN.fonts.font_1};
            font-size: 1rem;
            line-height: 1.4rem;
            word-wrap: normal;
            color: ${DESIGN_TOKEN.colors.swatch_3};
            p {
              text-align: center;
            }
          `}
        >
          <p>
            184 B Jones Road Falmouth, Massachusetts 02540 (508) 548-1050
            <br />
            {HTML_ENTITIES.copyright} 2020 The Sandpiper Nursery School, All
            rights reserved
          </p>
        </div>
      </Footer>
    </React.Fragment>
  );
}

const baseLayoutMemo = React.memo<BaseLayoutProps>(baseLayout);
export { baseLayoutMemo as BaseLayout };
